import { SideBar } from '../../models/sidebar.model';
import { assets } from './assets.const';

// export const ModuleConst = {
//   Dashboard: 1,
//   Customers: 2,
//   Merchants: 3,
//   DealsManagement: 4,
//   Categories: 5,
//   Bookings: 6,
//   Membership: 7,
//   Payment: 8,
//   Amenities: 9,
//   ReportAnalytics: 10,
//   Reviews: 11,
//   SubAdmin: 12,
//   Notifications: 13,
//   Settings: 14,
//   Cms: 15,
//   Logout: 16,
//   Banner: 17,
//   Partner: 18,
//   Packages: 19,
//   CustomBookings:20,
//   ManageQuery: 21
// };
export const ModuleConst = {
  Dashboard: "Dashboard",
  Customers: "ManageCustomers",
  Merchants: "Manage Partners",
  DealsManagement: "Manage Deal",
  Categories: "ManageCategories",
  Bookings: "Manage Bookings",
  Membership: "Manage Membership",
  Payment: "Manage Payment",
  Amenities: "Manage Amenities",
  ReportAnalytics: "Reports and Analytics",
  Reviews: "Manage Reviews",
  SubAdmin: "12",
  Notifications: "NotificationManagement",
  Settings: "Manage Setting",
  Cms: "ManageCMS",
  Logout: "16",
  Banner: "Partner Banner Management",
  Partner: "Manage Partners",
  Packages: "Manage Packages",
  CustomBookings: "Manage Custom Bookings",
  ManageQuery: "Manage Queries",
  Coupon: "Manage Coupon",
  MembershipApplication: "Membership Application"
};

export interface sidebarInterface {
  text: string;
  path?: string;
  img?: string;
  isSubMenu: boolean;
  subMenuItems?: sidebarInterface[];
}

export const sideBar: SideBar[] = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    img: assets.sidebarDashboardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Dashboard
  },
  {
    label: 'ManageCustomers',
    path: '/manage-customers',
    img: assets.UsersIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Customers
  },

  {
    label: 'Manage Partners',
    path: '/manage-partner',
    img: assets.MerchantIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Merchants
  },
  {
    label: 'Manage Deal',
    path: '/deals',
    img: assets.DealsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.DealsManagement
  },
  {
    label: 'ManageCategories',
    path: '/category',
    img: assets.CategoryIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Categories
  },
  {
    label: 'Manage Bookings',
    path: '/bookings',
    img: assets.BookingIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Bookings
  },
  {
    label: 'Manage Custom Bookings',
    path: '/custom-bookings',
    img: assets.BookingIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.CustomBookings
  },
  {
    label: 'Partner Banner Management',
    path: '/partner-banner',
    img: assets.AdIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Partner
  },
  {
    label: 'Manage Membership',
    path: '/membership-plans',
    img: assets.MembershipIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Membership
  },
  {
    label: 'Membership History',
    path: '/membership-history',
    img: assets.MembershipIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Membership
  },
  {
    label: 'Manage Payment',
    path: '/revenue',
    img: assets.RevenueIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Payment
  },
  {
    label: 'Manage Amenities',
    path: '/amenities',
    img: assets.AmenitiesIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Amenities
  },
  {
    label: 'Manage Packages',
    path: '/manage-packages',
    img: assets.package_icon,
    isSubMenu: false,
    sideBarId: ModuleConst.Packages
  },
  {
    label: 'Reports and Analytics',
    path: '/reports',
    img: assets.ReportIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.ReportAnalytics
  },
  {
    label: 'Manage Reviews',
    path: '/review',
    img: assets.ReviewIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Reviews
  },
  {
    label: 'Manage Queries',
    path: '/manage-query',
    img: assets.package_icon,
    isSubMenu: false,
    sideBarId: ModuleConst.Packages
  },
  {
    label: 'Manage Sub-Admin',
    path: '/subadmin',
    img: assets.SubadminIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SubAdmin
  },
  {
    label: 'NotificationManagement',
    path: '/notification',
    img: assets.NotificationIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Notifications
  },
  {
    label: 'Manage Setting',
    path: '/contact-support',
    img: assets.SettingIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Settings
  },
  {
    label: 'ManageCMS',
    path: '/cms',
    img: assets.CmsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Cms
  },
  {
    label: 'Manage Coupon',
    path: '/manage_coupon',
    img: assets.CouponsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Cms
  },
  {
    label:"Manage Travel Package",
    path:"/travel_package",
    img: assets.travelicon,
    isSubMenu: false,
    sideBarId: ModuleConst.Cms
  },
  {
    label:"Manage Travel Booking",
    path:"/travel_package_booking",
    img: assets.travelicon,
    isSubMenu: false,
    sideBarId: ModuleConst.Cms
  },
  {
    label: "Membership Application",
    path: "/membership-application",
    img: assets.MembershipIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Cms
  }

];
export const sideBar2: sidebarInterface[] = [
  {
    text: 'Merchant',
    path: '/manage-partner',
    isSubMenu: false
  },
  {
    text: 'Fine Dining',
    path: '/manage-partner/services/fine-dining',
    isSubMenu: false
  },
  {
    text: 'Luxury Yachts',
    path: '/manage-partner/services/luxury-yachts',
    isSubMenu: false
  },
  {
    text: 'Chauffer Driven Luxury Cars',
    path: '/manage-partner/services/chauffer-driven',
    isSubMenu: false
  },
  {
    text: 'Luxury Car Rentals',
    path: '/manage-partner/services/car-rental',
    isSubMenu: false
  },
  {
    text: 'Desert Adventures',
    path: '/manage-partner/services/desert-adventure',
    isSubMenu: false
  },
  {
    text: 'Helicopter Rides',
    path: '/manage-partner/services/helicopter-ride',
    isSubMenu: false
  }
];

export const sideBar3: sidebarInterface[] = [
  {
    text: 'Fine Dining',
    path: '/category',
    isSubMenu: false
  },
  {
    text: 'Luxury Yachts',
    path: '/category',
    isSubMenu: false
  },
  {
    text: 'Chauffer driven luxury cars',
    path: '/category',
    isSubMenu: false
  },
  {
    text: 'Luxury Car Rentals',
    path: '/category',
    isSubMenu: false
  },
  {
    text: 'Desert Adventures',
    path: '/category',
    isSubMenu: false
  },
  {
    text: 'Helicopter Rides',
    path: '/category',
    isSubMenu: false
  }
];
